import { useParams } from "react-router-dom";
import { TableCharge } from "../components/charges-management/TableCharge";

export const ChargePage = () => {
  const { chargeId } = useParams();

  return <TableCharge chargeId={chargeId} />;
};
